import React, {useEffect, useRef, useState} from 'react'
import Button from "../../../../UI/Button";
import "./TestBrand.scss"
import axios from "axios";
import {CSRF, SanitizeHTML} from "../../../../../constants";
import {useSelector} from "react-redux";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faGear} from "@fortawesome/free-solid-svg-icons";

const TestBrand = (props) => {
    const brand = useSelector(state => state.brands.selectedBrand)
    const textInp = useRef()
    const [message, setMessage] = useState()
    const [result, setResult] = useState()
    const [load, setLoad] = useState(false)


    const handleSubmit = (e) => {
        e.preventDefault()
        setLoad(true)

        axios({
            method: 'post',
            url: `/brands/${brand.id}/test`,
            data: {'text': textInp.current.value},
            headers: { 'Content-Type': 'application/json',
                'X-CSRF-Token': CSRF}
        }).then(json => {
            console.log(json.data)
            setLoad(false)

            if(json.data.success){
                setResult({reply: json.data.text, label: json.data.label})
            //     setTrigger(json.data.trigger)
            //     let text = ""
            //     if(json.data.score) {
            //         text = `Score: ${json.data.score}`
            //     }
            //     if(json.data.magnitude) {
            //         text = text + `, Magnitude: ${json.data.magnitude}`
            //     }
            //     text ? setTooltip(text) : setTooltip()
            //
            // }else{
            //     setTrigger()
            //     setTooltip()
            //     setResult("this comment would not be moderated")
            // }
            // if(json.data.admin_text){
            //     setAdminText(json.data.admin_text)
            }

        }).catch(errors => {
                setLoad(false)
            }
        );
    }


    const handleText = (e) => {
        setMessage(e.currentTarget.value)
        if(!e.currentTarget.value){
            setResult()
        }
    }

    return (
        <>
            <div className="test-block">
                  <div className="text-group w-100 mb-2">
                    <textarea className="form-control"
                              placeholder="Type your comment here..."
                              rows="5"
                              ref={textInp}
                              onKeyUp={handleText}></textarea>
                  </div>
                  <div className="row test-btn mx-0 reply-btn">
                    <div className="p-0">
                        {message && <Button className="btn btn-primary" clickHandler={handleSubmit}>
                            Process
                            <FontAwesomeIcon icon={faGear} spin={load} className="ms-2"/>
                        </Button>}
                    </div>
                  </div>
            </div>
            <div className="my-2">
                {result && message && (<>
                    <div><strong>Label: </strong>
                        <div className={`badge ${result?.label == "None" ? 'badge-light' : 'badge-light-green'} mx-2`}>
                            {result?.label}
                        </div>
                    </div>
                    <strong>Reply: </strong>
                    <SanitizeHTML html={result?.reply} className="mx-2 d-inline"/>
                    </>)}
            </div>
        </>

    )
}

export default React.memo(TestBrand)